import axios from 'axios';

const GEOLOCATION_API = 'https://validationapi.thetechmenders.com/api/GeoLocation/GetGeoLocation';
const LEAD_API = 'https://leadapi.crmbytes.com/api/Lead/AddLead';

export const getGeoLocation = async () => {
  try {
    const response = await axios.get(GEOLOCATION_API, {
      headers: {
        accept: 'text/plain',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching geolocation:', error);
    return null;
  }
};

export const submitLead = async (leadData) => {
  try {
    const response = await axios.post(LEAD_API, leadData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    console.error('Error submitting lead:', error);
    throw error;
  }
};
